import { SITE, FAQS } from "../data/site";
import { Breadcrumbs } from "../components/Breadcrumbs";
import { IconInstagram, IconArrowUpRight } from "../components/Icons";

export default function Faq() {
  return (
    <>
      <section className="mx-auto max-w-3xl px-5 pb-24 pt-28 md:pt-36">
        <Breadcrumbs items={[{ label: "FAQ", href: "/faq/" }]} />
        <p className="font-mono text-xs uppercase tracking-[0.25em] text-cheddar">Tanya Jawab</p>
        <h1 className="mt-3 font-display text-4xl uppercase tracking-tight text-cream sm:text-5xl lg:text-6xl">
          Yang sering ditanyakan
        </h1>
        <p className="mt-5 text-base leading-relaxed text-sand sm:text-lg">
          Seputar nama, outlet, jam buka, dan cara pesan Burger Blenger.
        </p>

        <div className="mt-12 space-y-4" data-testid="faq-list">
          {FAQS.map((f) => (
            <details
              key={f.id}
              data-testid={`faq-item-${f.id}`}
              className="group border border-white/10 bg-coal2 open:border-cheddar/40"
            >
              <summary className="flex cursor-pointer list-none items-center justify-between gap-4 p-5 font-display text-lg uppercase tracking-wide text-cream transition-colors hover:text-cheddar md:p-6 md:text-xl [&::-webkit-details-marker]:hidden">
                {f.q}
                <span
                  aria-hidden="true"
                  className="shrink-0 font-mono text-xl text-cheddar transition-transform duration-200 group-open:rotate-45"
                >
                  +
                </span>
              </summary>
              <p className="border-t border-dashed border-white/10 p-5 pt-4 text-sm leading-relaxed text-sand md:p-6 md:pt-5 md:text-base">
                {f.a}
              </p>
            </details>
          ))}
        </div>

        <div className="mt-14 border border-white/10 bg-coal2 p-8 text-center" data-testid="faq-cta">
          <h2 className="font-display text-xl uppercase tracking-wide text-cream sm:text-2xl">
            Masih ada pertanyaan?
          </h2>
          <p className="mx-auto mt-3 max-w-md text-sm leading-relaxed text-sand">
            Cara tercepat: kirim DM ke Instagram resmi kami. Atau langsung mampir
            ke outlet terdekat.
          </p>
          <div className="mt-6 flex flex-wrap justify-center gap-4">
            <a
              href={SITE.instagram}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="faq-instagram-button"
              className="btn-primary"
            >
              <IconInstagram className="h-4 w-4" /> DM {SITE.instagramHandle}
            </a>
            <a href="/lokasi/" data-testid="faq-location-button" className="btn-ghost">
              Lihat Lokasi <IconArrowUpRight className="h-4 w-4" />
            </a>
          </div>
        </div>
      </section>
    </>
  );
}
